// Copyright (C) 2022 LTTS
//
// SPDX-License-Identifier: MIT
import React from 'react';
import { Input, Button, Row, Col } from 'antd';
import Form from 'antd/lib/form';
import Text from 'antd/lib/typography/Text';
import { RouteComponentProps } from 'react-router';
import { Link, withRouter } from 'react-router-dom';
import Icon, { UserOutlined, MailOutlined } from '@ant-design/icons';
import Title from 'antd/lib/typography/Title';
import { BackArrowIcon } from 'icons';
// import { validatePassword } from 'components/register-page/register-form';

export interface LoginData {
    email: string;
}
interface Props {
    fetching: boolean;
    renderResetPassword: boolean;
    onSubmit(loginData: LoginData): void;
}

function LoginSSOFormComponent(props: Props & RouteComponentProps): JSX.Element {
    const { fetching, renderResetPassword, onSubmit } = props;
    return (
        <>
            <Form onFinish={onSubmit} autoComplete='off' className='login-form'>
                <Row justify='space-between'>
                    <Icon
                        className='form-SSO'
                        component={() => (
                            <Link to='/auth/login'>
                                <BackArrowIcon />
                            </Link>
                        )}
                    />
                </Row>
                <Row justify='space-between'>
                    <Col>
                        <p className='form-SSO'> Login with SSO </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text type='secondary' className='form-SSO1'>
                            Enter your company email
                        </Text>
                    </Col>
                </Row>
                <Form.Item
                    name='email'
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail!',
                        },
                        {
                            required: true,
                            message: 'Please specify an email address',
                        },
                    ]}
                >
                    <Input
                        className='login-form-field'
                        suffix={<UserOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />}
                        placeholder='Company mail'
                        autoComplete='off'
                    />
                </Form.Item>
                <Form.Item className='login-button-row'>
                    <Button
                        type='primary'
                        loading={fetching}
                        disabled={fetching}
                        htmlType='submit'
                        className='login-form-button'
                    >
                        Login
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default withRouter(LoginSSOFormComponent);
